import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare, faTag, faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import styles from "../../styles/common/AdditionalExternalServiceCard.module.css";
import upsTruckImg from "../../assets/images/ups_truck.jpg";
import elpaketVanImg from "../../assets/images/elpaket_van.jpg";

export interface AdditionalExternalServiceData {
  serviceName: string;
  serviceQty: number;
  servicePrice: number;
  serviceSubTotal: number;
  idExternalCourierService: number;
  transitDays: string | null;
  standardPrice?: number | null;
  discountPercent?: number | null;
}

interface AdditionalExternalServiceCardProps {
  pickupDate: string;
  onDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  minDate: string;
  maxDate: string;
  service: AdditionalExternalServiceData;
  isSelected: boolean;
  onClick: () => void;
  currency?: string;
  showDatePicker?: boolean;
}

export const AdditionalExternalServiceCard: React.FC<AdditionalExternalServiceCardProps> = ({
  pickupDate,
  onDateChange,
  minDate,
  maxDate,
  service,
  isSelected,
  onClick,
  currency = "USD",
  showDatePicker = true,
}) => {
  const isElpaket = service.serviceName.toUpperCase().includes("ELPAKET") || service.serviceName.toUpperCase().includes("TRANSPORTISTA");
  const illustrationImg = isElpaket ? elpaketVanImg : upsTruckImg;

  return (
    <div
      className={`${styles.cardContainer} ${isSelected ? styles.selected : ""}`}
      onClick={onClick}
    >
      <div className={styles.cardMainLayout}>
        <div className={styles.textContent}>
          <div className={styles.topRow}>
            <div className={styles.contentRow}>
              <div className={styles.checkWrapper}>
                {isSelected ? (
                  <FontAwesomeIcon icon={faCheckSquare} className={styles.checkIconActive} />
                ) : (
                  <FontAwesomeIcon icon={faSquare} className={styles.checkIconInactive} />
                )}
              </div>
              <span className={styles.serviceName}>{service.serviceName}</span>
            </div>
            {service.discountPercent && service.discountPercent > 0 && (
              <div className={styles.discountBadge}>
                <FontAwesomeIcon icon={faTag} className={styles.badgeIcon} />
                {service.discountPercent.toFixed(1)}% DESCUENTO
              </div>
            )}
          </div>

          <div className={styles.priceContainer}>
            <div className={styles.priceRow}>
              <span className={styles.priceValue}>
                ${service.serviceSubTotal.toFixed(2)}
              </span>
              <span className={styles.currency}>{currency}</span>
              {service.standardPrice && service.discountPercent && service.discountPercent > 0 && (
                <span className={styles.strikethroughPrice}>
                  ${service.standardPrice.toFixed(2)} {currency}
                </span>
              )}
            </div>
            <span className={styles.subtitleText}>
              {isElpaket ? "Recogida local directa por transportista ElPaket." : "Recogida programada por chofer oficial UPS."}
            </span>
          </div>
        </div>

        <div className={styles.illustrationWrapper}>
          <img src={illustrationImg} alt={service.serviceName} className={styles.cardIllustration} />
        </div>
      </div>

      {showDatePicker && (
        <div 
          className={`${styles.dateGroup} ${isSelected ? styles.dateGroupVisible : ""}`} 
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.dateHeader}>
            <label className={styles.dateLabel}>
              <FontAwesomeIcon icon={faCalendarAlt} className={styles.calendarIcon} />
              Fecha para Recalcular Recogida
            </label>
          </div>
          <div className={styles.dateInputWrapper}>
            <input
              type="date"
              name="pickupDate"
              value={pickupDate}
              onChange={onDateChange}
              min={minDate}
              max={maxDate}
              className={styles.dateInput}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdditionalExternalServiceCard;
